import Vue from 'vue'
import Vuex from 'vuex'
import { Tokenauthentication } from '../api/patient'
import createVuexAlong from 'vuex-along'
import '../utils/axiosRequest'
import { Message } from 'element-ui'
// import Home from '../views/Home.vue'
import router from '../router'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    Jumpid: '',
    user: {}, // 用户信息
    usert: {}, //,
    isLogin: false,
    rutset: '', // 课程详情页 记录跳转路径
    scxx: '课程评价',
    scxxpf: '课程收藏',
    scxxll: '学习记录',
    wdsc:'课程上传',
    height: '',
    resss: '',
    sucaixi: '',
    // 类
    zusc1: 1,
    ybcs: '',
    // https: 'http://39.103.207.199:112/',
    https: 'http://139.196.240.19/',
    hometz: 0,
    tzzx: '',
    issuser: '',
    kpwzxx:[],

  },
  mutations: {
    isUploadthetype (state, item) {
      state.issuser = item
    },
    zxxixvt (state, item) {
      state.tzzx = item
    },
    homres (state, item) {
      state.hometz = item
    },
    // 状态
    Stateofsss (state, item) {
      state.ybcs = item
    },
    // 状态
    Stateofthe1 (state, item) {
      state.zusc1 = item
    },
    sucaixingqi (state, item) {
      state.sucaixi = item
    },
    itemss (state, item) {
      state.resss = item
    },
    height (state, item) {
      state.height = item
    },
    scxxllid (state, item) {
      state.scxxll = item
    },
    // 收藏
    collection (state, item) {
      state.scxxpf = item
    },
    // 素材评价
    scrxi (state, item) {
      state.scxx = item
    },
      // wdsc
      wdsc (state, item) {
        state.wdsc = item
      },
    subset (state, item) {
      state.rutset = item
    },
    kpwzxx (state, item) {
      state.kpwzxx = item
    },
    Jumpfordetails (state, item) {
      state.Jumpid = item
    },
    userts (state, item) {
      state.usert = item
    },
    getUser (state, user) {
      state.user = user
    },
    checkToken (state, s) {
      state.isLogin = s
    }
  },
  actions: {
    // token 验证
    async  checkToken ({
      commit
    }) {
      var token = new FormData()
      token.append('token', localStorage.getItem('Token'))
      token.append('phone', this.state.user.phone)
      await Tokenauthentication(token).then(res => {
        if (res.code === 'OK') {
          commit('checkToken', true)
        } else if (res.code === 'ERR') {
          if (router.app._route.path === '/Myinfor' ||
            router.app._route.path === '/Mycollection' ||
            router.app._route.path === '/Learningecord' ||
            router.app._route.path === '/Myevaluation' ||
            router.app._route.path === '/Materialtoupload'
          ) {
            router.push({ path: '/Home' })
            Message({
              showClose: true,
              message: res.msg,
              type: 'error'
            })
          }

          commit('getUser', {})
          commit('checkToken', false)
        }
      })
    },
    // 保存用户信息
    getUser ({ commit }, user) {
      commit('getUser', user)
    }
  },
  modules: {},
  plugins: [createVuexAlong()]
})
